import type { ComponentProps, RefObject } from "react"
import type { IconSvgElement } from "@hugeicons/react"
import { HugeiconsIcon } from "@hugeicons/react"
import { Button } from "../ui"

type Props = Omit<ComponentProps<typeof Button>, "size"> & {
  icon: IconSvgElement
  size?: "icon" | "icon-xs" | "icon-sm" | "icon-lg"
  ref?: RefObject<HTMLAnchorElement | null>
}

export default function IconButton({
  icon,
  size = "icon",
  variant = "ghost",
  ...buttonProps
}: Props) {
  return (
    <Button size={size} variant={variant} {...buttonProps}>
      <HugeiconsIcon icon={icon} />
    </Button>
  )
}
